export const ResetPasswordRequestInit = {
    userEmail: "",
};
